import { render, staticRenderFns } from "./MainTopbar.vue?vue&type=template&id=23095fde&scoped=true&"
import script from "./MainTopbar.vue?vue&type=script&lang=js&"
export * from "./MainTopbar.vue?vue&type=script&lang=js&"
import style0 from "./MainTopbar.vue?vue&type=style&index=0&id=23095fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23095fde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VContainer,VSpacer})
